export const STR = {
  // Navbar
  nav_heritage: { bn: "ঐতিহ্য", en: "Heritage" },
  nav_schedule: { bn: "সময়সূচি", en: "Schedule" },
  nav_updates: { bn: "খবর", en: "Updates" },
  nav_gallery: { bn: "গ্যালারি", en: "Gallery" },
  nav_committee: { bn: "কমিটি", en: "Committee" },
  nav_donate: { bn: "অনুদান", en: "Donate" },
  nav_contact: { bn: "যোগাযোগ", en: "Contact" },
  nav_login: { bn: "সদস্য লগইন", en: "Member Login" },
  nav_dashboard: { bn: "ড্যাশবোর্ড", en: "Dashboard" },
  nav_donate_btn: { bn: "অনুদান করুন", en: "Donate" },
  nav_search_label: { bn: "খুঁজুন", en: "Search" },
  // Hero
  hero_theme: { bn: "বুনট — আদি ও নবের মেলবন্ধন", en: "Bunot — Where the Old Meets the New" },
  hero_est: { bn: "EST. ১৯৪৩ · ২০২৬", en: "EST. 1943 · 2026" },
  hero_title1: { bn: "রাজেন্দ্রলাল স্ট্রিট", en: "Rajendralal Street" },
  hero_title2: { bn: "সাধারণ দুর্গোৎসব কমিটি", en: "Sadharan Durgotsab Committee" },
  hero_sub: {
    bn: "মা আসছেন। ৮৩ বছরের ঐতিহ্য, ভালোবাসা আর একতার উৎসব — কলকাতার হৃদয়ে।",
    en: "Ma is coming. 83 years of tradition, love and togetherness — in the heart of Kolkata.",
  },
  hero_countdown: { bn: "ষষ্ঠী পর্যন্ত বাকি · COUNTDOWN", en: "TIME TO SHASHTHI · COUNTDOWN" },
  cd_days: { bn: "দিন", en: "DAYS" },
  cd_hours: { bn: "ঘণ্টা", en: "HOURS" },
  cd_mins: { bn: "মিনিট", en: "MIN" },
  cd_secs: { bn: "সেকেন্ড", en: "SEC" },
  hero_schedule_btn: { bn: "পূজোর সময়সূচি", en: "Puja Schedule" },
  hero_donate_btn: { bn: "পুজো ফান্ডে অনুদান", en: "Donate to the Fund" },
  hero_scroll: { bn: "নিচে স্ক্রল করুন", en: "Scroll down" },
  // Heritage
  her_eyebrow: { bn: "আমাদের ঐতিহ্য · SINCE 1943", en: "OUR HERITAGE · SINCE 1943" },
  her_title_a: { bn: "১৯৪৩ থেকে ২০২৬ —", en: "From 1943 to 2026 —" },
  her_title_b: { bn: "ঐতিহ্যের ৮৩ বছর", en: "83 Years of Tradition" },
  her_quote: {
    bn: "শুধু প্রতিমার আরাধনা নয়, মানুষের মধ্যে ভালোবাসার বন্ধনই হোক আমাদের দুর্গোৎসবের প্রকৃত পরিচয়।",
    en: "Not merely worship of the idol — let the bond of love among people be the true identity of our Durgotsab.",
  },
  her_card1_t: { bn: "রক্তদান শিবির", en: "Blood Donation Camp" },
  her_card1_s: { bn: "বছরের পর বছর ধরে নিয়মিত রক্তদান উৎসবের অঙ্গ", en: "Regular blood donation camps, year after year" },
  her_card2_t: { bn: "শাল ও বস্ত্র বিতরণ", en: "Shawl & Cloth Distribution" },
  her_card2_s: { bn: "দুঃস্থ ও অসহায় মানুষের পাশে কমিটির দায়িত্ব", en: "The committee's duty to stand beside the needy" },
  her_caption: { bn: "শারদোৎসব · আলোকসজ্জা", en: "SHARADOTSAV · FESTIVE LIGHTS" },
  // Schedule
  sch_eyebrow: { bn: "পূজোর সময়সূচি · ২০২৬", en: "PUJA SCHEDULE · 2026" },
  sch_title_a: { bn: "পাঁচ দিনের", en: "The Days of" },
  sch_title_b: { bn: "শারদোৎসব", en: "Sharadotsav" },
  sch_sub: { bn: "প্রতিটি তিথি, প্রতিটি মুহূর্ত — পঞ্জিকা মেনে আয়োজিত।", en: "Every tithi, every moment — observed by the almanac." },
  sch_gcal: { bn: "ক্যালেন্ডারে যোগ করুন", en: "Add to Calendar" },
  // Feed
  feed_eyebrow: { bn: "সর্বশেষ · UPDATES", en: "LATEST · UPDATES" },
  feed_title_a: { bn: "কমিটির", en: "Committee" },
  feed_title_b: { bn: "খবর ও ঘোষণা", en: "News & Announcements" },
  feed_sub: { bn: "ঘোষণা, অনুষ্ঠান, পূজোর আপডেট ও ডকুমেন্ট — সব এক জায়গায়।", en: "Announcements, events, puja updates and documents — all in one place." },
  feed_empty: { bn: "কমিটি সদস্যরা শীঘ্রই এখানে খবর যোগ করবেন।", en: "Committee members will add updates here soon." },
  feed_pinned: { bn: "পিন", en: "PINNED" },
  feed_share: { bn: "শেয়ার", en: "Share" },
  // Gallery
  gal_eyebrow: { bn: "ফটো অ্যালবাম · GALLERY", en: "PHOTO ALBUMS · GALLERY" },
  gal_title_a: { bn: "বিগত বছরের", en: "Moments from" },
  gal_title_b: { bn: "মুহূর্ত", en: "Past Years" },
  gal_sub: { bn: "বছর ধরে সাজানো আমাদের পুজোর স্মৃতি।", en: "Memories of our puja, arranged year by year." },
  gal_empty: { bn: "এখনও কোনও অ্যালবাম যোগ করা হয়নি।", en: "No albums have been added yet." },
  // Committee
  com_eyebrow: { bn: "কমিটি · THE TEAM", en: "COMMITTEE · THE TEAM" },
  com_title_a: { bn: "আয়োজনের পেছনের", en: "The People" },
  com_title_b: { bn: "মানুষরা", en: "Behind the Festival" },
  // Donate
  don_eyebrow: { bn: "অনুদান · PUJA FUND", en: "DONATE · PUJA FUND" },
  don_title_a: { bn: "পুজো ফান্ডে", en: "Donate to the" },
  don_title_b: { bn: "অনুদান করুন", en: "Puja Fund" },
  don_anjali: { bn: "ডিজিটাল অঞ্জলি", en: "Digital Anjali" },
  don_custom_ph: { bn: "ইচ্ছামতো ₹", en: "Custom ₹" },
  don_name_ph: { bn: "আপনার নাম (ঐচ্ছিক)", en: "Your name (optional)" },
  don_scan: {
    bn: "GPay / PhonePe / BHIM দিয়ে QR স্ক্যান করে ₹{amt} দান করুন।",
    en: "Scan the QR with GPay / PhonePe / BHIM to donate ₹{amt}.",
  },
  don_pay: { bn: "UPI অ্যাপ খুলুন", en: "Open UPI App" },
  don_confirm: { bn: "আমি দান করেছি", en: "I have donated" },
  don_wa: { bn: "পেমেন্টের স্ক্রিনশট হোয়াটসঅ্যাপে পাঠান →", en: "Send the payment screenshot on WhatsApp →" },
  don_fallback: {
    bn: "ইউপিআই QR শীঘ্রই যোগ করা হবে — এখন নিচের নম্বরে কল বা হোয়াটসঅ্যাপ করে দান করুন।",
    en: "The UPI QR will be added soon — for now, please call or WhatsApp the numbers below to donate.",
  },
  don_card1: { bn: "সম্পাদকীয় যোগাযোগ", en: "SECRETARY CONTACT" },
  don_card2: { bn: "অফিস যোগাযোগ", en: "OFFICE CONTACT" },
  don_call: { bn: "কল করুন", en: "Call" },
  don_wa_btn: { bn: "হোয়াটসঅ্যাপ", en: "WhatsApp" },
  don_note: {
    bn: "সমস্ত অনুদান ব্যয় হয় পূজো আয়োজন, অন্নকূট বিতরণ ও সমাজসেবামূলক কাজে।",
    en: "All donations go toward the puja arrangements, annakut distribution and social work.",
  },
  don_img_t: { bn: "আপনার অনুদানেই জেগে থাকে এই উৎসব", en: "Your donation keeps this festival alive" },
  don_img_s: { bn: "প্রতিটি চমক, প্রতিটি প্রদীপ — ভক্তদের ভালোবাসার অর্থে।", en: "Every sparkle, every lamp — funded by the love of devotees." },
  don_thanks: { bn: "জয় মা দুর্গা! আপনার অনুদানের জন্য আন্তরিক ধন্যবাদ।", en: "Jai Maa Durga! Heartfelt thanks for your donation." },
  // Contact
  con_eyebrow: { bn: "যোগাযোগ · FIND US", en: "CONTACT · FIND US" },
  con_title_a: { bn: "পণ্ডালে", en: "You Are Invited" },
  con_title_b: { bn: "সপরিবারে আমন্ত্রণ", en: "With Your Family" },
  con_landmark: { bn: "ল্যান্ডমার্ক —", en: "Landmark —" },
  con_map: { bn: "Google Maps-এ দেখুন", en: "View on Google Maps" },
  con_phone: { bn: "ফোন", en: "Phone" },
  con_wa: { bn: "হোয়াটসঅ্যাপ", en: "WhatsApp" },
  con_email: { bn: "ইমেইল", en: "Email" },
  con_fb: { bn: "ফেসবুক", en: "Facebook" },
  con_ig: { bn: "ইনস্টাগ্রাম", en: "Instagram" },
  con_form_t: { bn: "বার্তা পাঠান / স্বেচ্ছাসেবক হোন", en: "Send a message / volunteer" },
  con_name_ph: { bn: "আপনার নাম", en: "Your name" },
  con_phone_ph: { bn: "ফোন নম্বর (ঐচ্ছিক)", en: "Phone number (optional)" },
  con_msg_ph: { bn: "আপনার বার্তা লিখুন...", en: "Write your message..." },
  con_submit: { bn: "বার্তা পাঠান", en: "Send Message" },
  con_sending: { bn: "পাঠানো হচ্ছে...", en: "Sending..." },
  con_success: { bn: "আপনার বার্তা পাঠানো হয়েছে — ধন্যবাদ!", en: "Your message has been sent — thank you!" },
  // Footer
  fot_rights: { bn: "সর্বস্বত্ব সংরক্ষিত", en: "All rights reserved" },
  fot_tagline: { bn: "জয় মা দুর্গা · শুভ শারদীয়া", en: "Jai Maa Durga · Shubho Sharodiya" },
  fot_login: { bn: "সদস্য লগইন", en: "Member Login" },
  // Search
  search_ph: { bn: "খবর, ঘোষণা বা অনুষ্ঠান খুঁজুন...", en: "Search news, announcements, events..." },
  search_busy: { bn: "খোঁজা হচ্ছে...", en: "Searching..." },
  search_empty: { bn: "কিছু পাওয়া যায়নি — অন্য শব্দে খুঁজে দেখুন।", en: "Nothing found — try a different word." },
  // Bell
  bell_title: { bn: "সর্বশেষ নোটিফিকেশন", en: "LATEST NOTIFICATIONS" },
  bell_empty: { bn: "এখনও কোনও নোটিফিকেশন নেই।", en: "No notifications yet." },
  push_on: { bn: "পুশ নোটিফিকেশন চালু আছে", en: "Push notifications are on" },
  push_denied: { bn: "ব্রাউজারে পুশ বন্ধ — সেটিংস থেকে চালু করুন", en: "Push blocked in browser — enable in settings" },
  push_unsupported: { bn: "এই ব্রাউজারে পুশ সমর্থিত নয়", en: "Push is not supported on this browser" },
  push_enable: { bn: "ব্রাউজার নোটিফিকেশন চালু করুন", en: "Enable browser notifications" },
  push_toast_ok: { bn: "নোটিফিকেশন চালু হয়েছে — নতুন খবরের ঘণ্টা পড়বে!", en: "Notifications on — you will hear the bell for new updates!" },
  push_toast_err: { bn: "পুশ চালু করা গেল না — ব্রাউজার সেটিংস দেখুন", en: "Could not enable push — check browser settings" },
  ago_now: { bn: "এইমাত্র", en: "just now" },
  ago_min: { bn: "{n} মিনিট আগে", en: "{n} min ago" },
  ago_hr: { bn: "{n} ঘণ্টা আগে", en: "{n} hrs ago" },
  ago_day: { bn: "{n} দিন আগে", en: "{n} days ago" },
  // Login & signup
  tab_login: { bn: "লগইন", en: "Log In" },
  tab_signup: { bn: "সাইন আপ", en: "Sign Up" },
  log_title: { bn: "সদস্য লগইন", en: "Member Login" },
  log_sub: { bn: "শুধুমাত্র কমিটির অনুমোদিত সদস্যদের জন্য", en: "For approved committee members only" },
  log_id_label: { bn: "ফোন বা ইমেইল", en: "Phone or email" },
  log_id_ph: { bn: "৯০৫১৯ ৩৩৩৩৩১", en: "9051933331" },
  log_pw_label: { bn: "পাসওয়ার্ড", en: "Password" },
  log_submit: { bn: "লগইন", en: "Log In" },
  log_busy: { bn: "লগইন হচ্ছে...", en: "Logging in..." },
  log_forgot: { bn: "পাসওয়ার্ড ভুলে গেছেন? অ্যাডমিনের সঙ্গে যোগাযোগ করুন — 9051933331", en: "Forgot password? Contact an admin — 9051933331" },
  log_back: { bn: "← ওয়েবসাইটে ফিরে যান", en: "← Back to the website" },
  log_welcome: { bn: "স্বাগতম! ড্যাশবোর্ডে যাচ্ছেন...", en: "Welcome! Taking you to the dashboard..." },
  sign_title: { bn: "সদস্যপদের অনুরোধ", en: "Membership Request" },
  sign_sub: { bn: "কমিটি আপনার অনুরোধ দেখে অ্যাক্সেস দেবে", en: "The committee will review and grant access" },
  sign_name: { bn: "আপনার নাম", en: "Your name" },
  sign_phone: { bn: "ফোন নম্বর (১০ সংখ্যার)", en: "Phone number (10 digits)" },
  sign_email: { bn: "ইমেইল (ঐচ্ছিক)", en: "Email (optional)" },
  sign_reason: { bn: "কেন যুক্ত হতে চান? (ঐচ্ছিক)", en: "Why do you want to join? (optional)" },
  sign_submit: { bn: "অনুরোধ পাঠান", en: "Send Request" },
  sign_busy: { bn: "পাঠানো হচ্ছে...", en: "Sending..." },
  sign_success_t: { bn: "অনুরোধ জমা হয়েছে!", en: "Request received!" },
  sign_success_s: { bn: "কমিটি আপনার অনুরোধ দেখে লগইন অ্যাক্সেস দেবে — তারপর এই পেজ থেকে লগইন করুন।", en: "The committee will review your request and grant login access — then log in from this page." },
};
